// @flow

import ExtendableError from 'utils/ExtendableError';

export default class NetworkError extends ExtendableError {}
